
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
  import {
    orderInvoiceorderInvoiceDetailList
  } from "@/api/finance"
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })
  export default class ProductList extends Vue {
    private state = null
    private stateList = [
      {value:null,label:'全部'},
      {value:1,label:'已开票'},
      {value:0,label:'未开票'},
    ]
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 20
    private total = 0




    private mounted () {
      this.gettablelist()
    }


    private toDetails(row){
      this.$router.push({
        path:'userInvoiceScheduleDetailsData',
        query:{
          ...this.$route.query,
          Id:row.Id
        }
      })
    }
    private iframDown(url,item){
			const xhr:any = new XMLHttpRequest();
			xhr.open('GET', location.origin+'/image/server?url='+url, true);
			xhr.responseType = 'blob'; // 设置响应类型为blob
			xhr.onload = function(e) {
				console.log(this,1)
				if (this.status === 200) {
					const blob = this.response; // 获取blob对象
					console.log(blob);
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = item.OrderNo+'发票';
					link.target = '_blank';
					// return
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(blob)
				}
			};
			xhr.send();
		}
    private downloadFile(row){
      this.iframDown(row.InvoiceUrlComplete,row)
    }
    private tocopy(e,row){
      let text = ''
      text += '发票抬头：' + row.RecipientName +'\n'
      text += '税号：' + row.VATNumber  +'\n'
      text += '公司地址：' + row.CompanyAddress  +'\n'
      text += '公司电话：' + row.CompanyPhone  +'\n'
      text += '开户行：' + row.BankName + row.BranchName  +'\n'
      text += '银行账号；' + row.BankAccountNumber  +'\n'
      text += '开票金额：' + row.ProductInvoiceMoney  +'\n'
      text += '订单编号：' + row.OrderNo  +'\n'
      text += '下单人：' + row.WxNickname  +'\n'
      text += '下单时间：' + row.AddTime  +'\n'
      text += '商品明细：' + row.ProductName + '*' + row.ProductCount  +'\n'
      text += '供应商：' + row.CompanyName  +'\n'
      text += '开票状态：' + row.InvoiceStateValue  +'\n'
      
      handleClipboard(text,e)
    }
    private clearSearch(){
      this.state = null
      this.keywords = ''
      this.doSearch()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await orderInvoiceorderInvoiceDetailList({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          ...this.$route.query,
          InvoiceState:this.state,
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
